import { render, staticRenderFns } from "./LegalInfo.vue?vue&type=template&id=0fba1738&"
import script from "./LegalInfo.vue?vue&type=script&lang=js&"
export * from "./LegalInfo.vue?vue&type=script&lang=js&"
import style0 from "./LegalInfo.vue?vue&type=style&index=0&id=0fba1738&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports